import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/pages/Login/LoginComponent";
import Profile from "./components/pages/Profile/ProfileComponent";
import Settings from "./components/pages/Settings/SettingsComponent";
import History from "./components/pages/History/HistoryComponent";
import HistoryDetail from "./components/pages/HistoryDetail/HistoryDetailComponent";
import React, { useState, useEffect, useCallback } from "react";
import io from "socket.io-client";



function App() {
    const [socket, setSocket] = useState(null);
    const [socketError, setSocketError] = useState(false);
    const [socketReady, setSocketReady] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [token, setToken] = useState(localStorage.getItem('token') || null);

    const [userId, setUserId] = useState("");


    // Функция для установки токена
    const setAuthToken = useCallback((newToken) => {
        setToken(newToken);
        if (newToken) {
            localStorage.setItem('token', newToken);
        } else {
            localStorage.removeItem('token');
        }
    }, []);

    // Функция для выхода
    const logout = useCallback(() => {
        setAuthToken(null);
        setIsAuthenticated(false);
        if (socket) {
            socket.disconnect();
            setSocket(null);
            setSocketReady(false);
        }
    }, [socket, setAuthToken]);

    useEffect(() => {

        if (window.Telegram && window.Telegram.WebApp) {
            const tele = window.Telegram.WebApp;
            tele.ready();
            setUserId(tele.initDataUnsafe?.user.id);
            
        }
        let socketInstance = null;

        if (token) {
            socketInstance = io("https://newapi.click", {
                auth: {
                    token: token,
                },
                reconnection: true,
                reconnectionAttempts: 5,
            });

            socketInstance.on("connect", () => {
                socketInstance.emit("ping", (response) => {
                    if (response === "pong") {
                        setSocketReady(true);
                        setSocketError(false);
                        setIsAuthenticated(true); // Устанавливаем статус аутентификации
                    } else {
                        console.error("Ping failed:", response);
                        setSocketError(true);
                        setIsAuthenticated(false);
                    }
                });
            });


            socketInstance.on("connect_error", (err) => {
                console.error("Socket connection error:", err.message);

                // Если ошибка связана с невалидным токеном, очищаем токен и выполняем выход
                if (err.message === "Invalid token") {
                    logout();
                }

                setSocketError(true);
                setIsAuthenticated(false);
            });

            // Устанавливаем сокет только один раз
            setSocket(socketInstance);

            return () => {
                if (socketInstance) {
                    socketInstance.disconnect();
                }
            };
        } else {
            setSocket(null);
            setSocketReady(false);
            setIsAuthenticated(false);
        }
    }, [token]); // Убрали зависимость от `logout`

    if (socketError) {
        return (
            <div> 
            </div>
        );
    }

    if (token && !socketReady) {
        return <div></div>;
    }

    return (
        <Router>
            <Routes>
                <Route path="/" element={isAuthenticated ? <Navigate to="/profile" /> : <Login setAuthToken={setAuthToken} telegramId={userId} />} />
                <Route path="/profile" element={isAuthenticated ? <Profile socket={socket} logout={logout} /> : <Navigate to="/" />} />
                <Route path="/settings" element={isAuthenticated ? <Settings socket={socket} /> : <Navigate to="/" />} />
                <Route path="/history" element={isAuthenticated ? <History socket={socket} /> : <Navigate to="/" />} />
                <Route path="/history/:id" element={isAuthenticated ? <HistoryDetail socket={socket} /> : <Navigate to="/" />} />
            </Routes>
        </Router>
    );
}

export default App;